export enum OptionStatus {
  Correct,
  Default,
  Disabled,
  Incorrect,
  Selected,
  Unselected,
}
